module.exports = __webpack_public_path__ + "static/media/img98_R.27e5f2f4.jpg";